import { Helmet } from 'react-helmet-async';
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import FleetSection from "../components/FleetSection";
import ReviewsSection from "../components/ReviewsSection";
import Footer from "../components/Footer";
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-cinzel text-gold text-center mb-12">
          Our Premium Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className="bg-black/50 border border-gold/20 rounded-lg p-6 hover:border-gold transition-colors">
            <h3 className="text-xl font-cinzel text-gold mb-4">Executive Airport Transfer</h3>
            <p className="text-white/80 mb-4">Premium airport transportation with flight tracking and meet & greet service.</p>
            <Link to="/services" className="text-gold hover:text-gold/80 transition-colors inline-flex items-center">Learn More<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg></Link>
          </div>
          <div className="bg-black/50 border border-gold/20 rounded-lg p-6 hover:border-gold transition-colors">
            <h3 className="text-xl font-cinzel text-gold mb-4">Hourly/As Direct</h3>
            <p className="text-white/80 mb-4">Flexible hourly transportation service tailored to your specific needs and schedule.</p>
            <Link to="/services" className="text-gold hover:text-gold/80 transition-colors inline-flex items-center">Learn More<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg></Link>
          </div>
          <div className="bg-black/50 border border-gold/20 rounded-lg p-6 hover:border-gold transition-colors">
            <h3 className="text-xl font-cinzel text-gold mb-4">Corporate & Leisure</h3>
            <p className="text-white/80 mb-4">Professional chauffeur services for business and leisure travel needs.</p>
            <Link to="/services" className="text-gold hover:text-gold/80 transition-colors inline-flex items-center">Learn More<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg></Link>
          </div>
          <div className="bg-black/50 border border-gold/20 rounded-lg p-6 hover:border-gold transition-colors">
            <h3 className="text-xl font-cinzel text-gold mb-4">Sporting Event Transfers</h3>
            <p className="text-white/80 mb-4">Luxury transportation to and from sporting events with dedicated service.</p>
            <Link to="/services" className="text-gold hover:text-gold/80 transition-colors inline-flex items-center">Learn More<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg></Link>
          </div>
          <div className="bg-black/50 border border-gold/20 rounded-lg p-6 hover:border-gold transition-colors">
            <h3 className="text-xl font-cinzel text-gold mb-4">Wedding & Special Events</h3>
            <p className="text-white/80 mb-4">Elegant transportation services for weddings and special celebrations.</p>
            <Link to="/services" className="text-gold hover:text-gold/80 transition-colors inline-flex items-center">Learn More<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg></Link>
          </div>
          <div className="bg-black/50 border border-gold/20 rounded-lg p-6 hover:border-gold transition-colors">
            <h3 className="text-xl font-cinzel text-gold mb-4">Medical Transportation</h3>
            <p className="text-white/80 mb-4">Comfortable and reliable transportation for medical appointments and procedures.</p>
            <Link to="/services" className="text-gold hover:text-gold/80 transition-colors inline-flex items-center">Learn More<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg></Link>
          </div>
        </div>
      </div>
    </section>
  );
};

const Index = () => {
  console.log('Index component rendering');
  return (
    <>
      <Helmet>
        <title>TiLimousine – Luxury Chauffeur Service</title>
        <meta name="description" content="TiLimousine offers premium chauffeur services for airport transfers, corporate travel, and events." />
        <link rel="canonical" href="https://tilimousine.com/" />
      </Helmet>
      <div className="min-h-screen bg-black">
        <Navbar />
        <main className="bg-black">
          <section id="hero">
            <HeroSection 
              title="Premium Chauffeur Service"
              subtitle="Experience luxury transportation with our professional chauffeur service"
              ctaText="Book Your Ride"
              ctaLink="/contact"
            />
          </section>
          <ServicesSection />
          <section id="fleet" className="scroll-mt-20 bg-black">
            <FleetSection />
          </section>
          <section id="reviews" className="scroll-mt-20 bg-black">
            <ReviewsSection />
          </section>
          <Footer />
        </main>
      </div>
    </>
  );
};

export default Index;